import React, { Component } from "react";
import Dropdown from "semantic-ui-react/dist/es/modules/Dropdown";
import { Icon } from "semantic-ui-react";
import Select, { components } from "react-select";
import CustomDropdown from "../Charts/ChartsOptionsSidebar/CustomDropdown";

const IndicatorsContainer = ({ children, ...props }) => {
    return (
        <components.IndicatorsContainer {...props}>
            <div className="react-select-control">
                {children}
                {/* <p>hello</p> */}
                <Icon style={{ marginTop: 3 }} name={"caret down"} />
            </div>
        </components.IndicatorsContainer>
    );
};

const customStyles = {
    control: (base) => ({ ...base, border: 0, boxShadow: "none", background: "#F5F6FA", height: "36px", minHeight: "36px" }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return { ...styles, backgroundColor: isFocused ? "#F5F6FA" : null, color: "#1f2e3d", opacity: isDisabled ? 0.5 : 1 };
    },
    dropdownIndicator: (provided, state) => ({
        ...provided,
        transform: state.selectProps.menuIsOpen && "rotate(180deg) translateY(5px)",
    }),

    menuList: (base) => ({
        ...base,
        padding: "7px",
        margin: "4px",
        fontSize: 14,

        "::-webkit-scrollbar": {
            width: "2px",
        },
        "::-webkit-scrollbar-track": {
            background: "white",
        },
        "::-webkit-scrollbar-thumb": {
            background: "white",
        },
        "::-webkit-scrollbar-thumb:hover": {
            background: "white",
        },
    }),
};

class InfluencerSelector extends Component {
    state = {};

    handleInfluencerChange = (d) => {
        this.props.handleInfluencerChange(d);
    };

    render() {
        const aggsIntervalOptions = [
            { key: "default", label: "All", value: "yes" },
            { key: "INFLUENCERS", label: "INFLUENCERS", value: "positive" },
            { key: "DETRACTORS", label: "DETRACTORS", value: "negative" },
        ];

        let obj =
            this.props.appliedFilter && this.props.appliedFilter.sentiment
                ? aggsIntervalOptions.find((o) => o.value === this.props.appliedFilter.sentiment).value
                : "yes";

        return (
            // <Dropdown
            //     value={this.props.aggs_val}
            //     disabled={this.props.loading}
            //     placeholder={obj}
            //     onChange={(e, d) => this.handleInfluencerChange(d.value)}
            //     selection
            //     options={aggsIntervalOptions}
            // />
            <CustomDropdown
                className="interval-selector"
                name="Influencer Type"
                onChange={this.handleInfluencerChange}
                value={obj}
                options={aggsIntervalOptions}
            />
        );
    }
}

export default InfluencerSelector;
